/**
 * TorusMesh decode. Defaults: `primitive_meshes.h:377-380`. `set_rings`
 * (`primitive_meshes.cpp:2348`) and `set_ring_segments` (:2361) ERR_FAIL below 3,
 * keeping the default. The radii have no setter guard (:2320, :2332): Godot swaps
 * or refuses them at surface build (:2232-2241), so that lives in `build.ts`.
 */
import { realOr, settableIntOr } from '../../../parser/valueParsers';
export function decodeTorusMesh(properties) {
    return {
        innerRadius: realOr(properties.inner_radius, 0.5, 'TorusMesh inner_radius'),
        outerRadius: realOr(properties.outer_radius, 1.0, 'TorusMesh outer_radius'),
        rings: settableIntOr(properties.rings, 64, { min: 3 }, 'TorusMesh rings'),
        ringSegments: settableIntOr(properties.ring_segments, 32, { min: 3 }, 'TorusMesh ring_segments'),
    };
}
//# sourceMappingURL=decode.js.map